<template>
  <div class="content" @click.stop="$emit('copy')">
    <div class="inline-block mr-1">
      <CopyIcon />
    </div>
    <span class="text">复制内容</span>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import CopyIcon from '../assets/Copy.vue';
@Component({
  components: {
    CopyIcon
  }
})
export default class CopyCodeBtn extends Vue {}
</script>
<style scoped>
.content {
  @apply absolute top-2 right-4 flex items-center cursor-pointer;
}
@screen md {
  .content:hover .text {
    color: #433eff;
  }
  .content:hover /deep/ path {
    fill: #433eff;
  }
}
.content:active .text {
  color: #433eff;
}
.content:active /deep/ path {
  fill: #433eff;
}
.text {
  color: #79789a;
  font-size: 12px;
}
</style>
